import {
  type CustomFieldGetInput,
  type CustomFieldGetSuccess,
  type CustomFieldData,
  type CustomFieldId,
} from '@terros/common'
import { useTantalimQuery } from '../query'
import { type GetHookResponse } from '../hooks'
import { customFieldKey } from './keys'

export function useCustomField(fieldId: CustomFieldId): GetHookResponse<CustomFieldData> {
  return useTantalimQuery<CustomFieldGetInput, CustomFieldGetSuccess, CustomFieldData>({
    url: '/customField/get',
    queryKey: customFieldKey(fieldId),
    input: {
      fieldId,
    },
    convertResponse: (data) => data.customField,
  })
}
